/**
 * Sets the sessionStorage object for the given field
 * @param {HTMLElement} field The HTML element
 * @param {string} key The Storage key to be set
 * @returns {void}
 */
export const persistFieldValueInSession = (field, key) => {
  if (!field) {
    return;
  }

  if (field.name === 'email') {
    field.addEventListener('change', (event) => {
      window.sessionStorage.setItem(key, event.target.value);
    });
  }

  window.sessionStorage.setItem(key, field.value);
};

/**
 *
 * @param {HTMLElement} field The HTML element
 * @param {string} key The Storage key to retrieve
 * @returns {void}
 */
export const populateFieldValueWithSession = (field, key) => {
  const item = window.sessionStorage.getItem(key);

  if (!item) {
    return;
  }

  field.value = item;
  window.sessionStorage.removeItem(key);
};
